import { PlaceType } from 'owa-location-service';
export default {
    getPlace: {
        datapoint: {
            name: 'getPlace',
            customData: (type: PlaceType, statusCode: number, error: string) => [
                type,
                statusCode,
                error,
            ],
        },
    },

    locationCardShown: {
        datapoint: {
            name: 'LocationCardShown',
            customData: (
                type: PlaceType,
                addressDetails: number,
                roomDetails: number,
                extendedDetails: number
            ) => [type, addressDetails, roomDetails, extendedDetails],
        },
    },

    openWebsite: {
        datapoint: { name: 'openWebsite' },
    },

    openDirections: {
        datapoint: {
            name: 'openDirections',
            customData: (source: string) => [source],
        },
    },

    call: {
        datapoint: {
            name: 'call',
            customData: (source: string) => [source],
        },
    },

    toggleOpeningHours: {
        datapoint: {
            name: 'toggleOpeningHours',
            customData: (state: string) => [state],
        },
    },
};
